import { useState } from "react";
import { useQuery, useMutation } from "convex/react";
import { api } from "convex/_generated/api";
import { Mail, Plus, Trash2 } from "lucide-react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";

export function TrustedEmailsManager() {
  const trustedEmails = useQuery(api.moderation.getTrustedEmails);
  const addTrustedEmail = useMutation(api.moderation.addTrustedEmail);
  const removeTrustedEmail = useMutation(api.moderation.removeTrustedEmail);
  const [newEmail, setNewEmail] = useState("");
  const [notes, setNotes] = useState("");

  const handleAdd = async () => {
    if (!newEmail.trim()) return;
    await addTrustedEmail({ email: newEmail.trim(), notes: notes.trim() || undefined });
    setNewEmail("");
    setNotes("");
  };

  return (
    <section>
      <h2 className="font-semibold text-lg text-foreground mb-4 flex items-center gap-2">
        <Mail className="w-5 h-5" />
        Trusted Emails
      </h2>

      {/* Add form */}
      <div className="flex gap-2 mb-4">
        <Input
          value={newEmail}
          onChange={(e) => setNewEmail(e.target.value)}
          placeholder="email@example.com"
          type="email"
          className="flex-1"
        />
        <Input
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          placeholder="Notes (optional)"
          className="flex-1"
        />
        <Button size="sm" onClick={handleAdd} disabled={!newEmail.trim()}>
          <Plus className="w-4 h-4" />
          Add
        </Button>
      </div>

      {/* List */}
      {trustedEmails === undefined ? (
        <div className="h-20 bg-secondary/30 rounded-lg animate-pulse" />
      ) : trustedEmails.length === 0 ? (
        <div className="text-center py-6 bg-card rounded-xl border border-border/50">
          <p className="text-sm text-muted-foreground">No trusted emails yet.</p>
        </div>
      ) : (
        <div className="space-y-2">
          {trustedEmails.map((entry) => (
            <div
              key={entry._id}
              className="flex items-center justify-between bg-card rounded-lg border border-border/50 px-4 py-2"
            >
              <div>
                <span className="text-sm text-foreground">{entry.email}</span>
                {entry.notes && (
                  <span className="text-xs text-muted-foreground ml-2">
                    ({entry.notes})
                  </span>
                )}
              </div>
              <Button
                variant="ghost"
                size="sm"
                className="text-muted-foreground hover:text-destructive"
                onClick={() => removeTrustedEmail({ emailId: entry._id })}
              >
                <Trash2 className="w-4 h-4" />
              </Button>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
